module.exports = __webpack_public_path__ + "img/sport-89-@3x.f07f7fe1.png";